import { render, staticRenderFns } from "./printJSPurchases.vue?vue&type=template&id=5489d140&scoped=true&"
import script from "./printJSPurchases.vue?vue&type=script&lang=js&"
export * from "./printJSPurchases.vue?vue&type=script&lang=js&"
import style0 from "./printJSPurchases.vue?vue&type=style&index=0&id=5489d140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489d140",
  null
  
)

component.options.__file = "printJSPurchases.vue"
export default component.exports